// InsideFlashFluency/index.js
import React from 'react';
import { Link } from 'react-router-dom';
import { post as introducingPlusOneSRSMeta } from './BlogPosts/IntroducingPlusOneSRS';
// Import additional posts similarly

const posts = [
  introducingPlusOneSRSMeta,
  // Add new post metadata objects here
];

export default function BlogIndex() {
  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">Inside Flash Fluency</h1>
      <div className="space-y-4">
        {posts.map((post) => (
          <div key={post.slug} className="p-4 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow">
            <h2 className="text-2xl font-semibold">
              <Link to={post.slug} className="text-blue-500 hover:underline">
                {post.title}
              </Link>
            </h2>
            <p className="text-gray-600">{post.summary}</p>
            <p className="text-sm text-gray-500">{post.date}</p>
          </div>
        ))}
      </div>
    </div>
  );
}